module.exports = __webpack_public_path__ + "static/media/sue.dd8b163c.png";